module.exports = __webpack_public_path__ + "8aee605a7538a4eee3efeb35c725cb5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-2.jpg
// module id = 1112
// module chunks = 1